import type { SelectOptionPropsType } from '@Shelly/shelly-design-system';

export type SelectOptionPropsTypeExtended = SelectOptionPropsType & {
	translationDefault?: string;
};

export const defaultSelectedRoom: SelectOptionPropsTypeExtended = {
	title: 'filter_all_rooms',
	value: 'all',
	translationDefault: 'All rooms',
};

export const defaultHiddenDevicesRoom: SelectOptionPropsTypeExtended = {
	title: 'hidden_devices',
	value: -10,
	translationDefault: 'Hidden devices',
};

// The default shared device room id is set to -20 when device is shared
export const defaultSharedDevicesRoom: SelectOptionPropsTypeExtended = {
	title: 'shared_devices',
	value: -20,
	translationDefault: 'Recently shared devices',
};

export const defaultAllSharedDevicesRoom: SelectOptionPropsTypeExtended = {
	title: 'all_shared_devices',
	value: -40,
	translationDefault: 'All shared devices',
};

export const defaultThermostatFilter: SelectOptionPropsTypeExtended = {
	title: 'filter_all_thermostats',
	translationDefault: 'All thermostats',
	value: '',
};

export const doubleTimePickerBreakpoint = 370;

export const defaultAppBackgroundSrc = 'images/home_def/app_bg_01.png';

export const defaultDashboardSettings = {
	havePicture: true,
	haveHeading: true,
	//haveSubheading: true,
	haveSmallParams: true,
	haveBigParams: true,
};

// Firmware versions for secure type issues like enhanced security, bluetooth pairing, etc.
export const secureModeFirmwareVersions = '1.8.9';
